import React from 'react'
import { Modal, Button, Row, Col, Spin } from 'antd'
import moment from 'moment'
import { connect } from 'react-redux'

import { getImageChannel } from '../../../../constants/order'
import TableItem from './split-table'
import './styles.css'
import { showConfirm, alertSplitSuccess } from '../../../../services/dialog'
import { splitOrders } from '../../../../utils/orders'
import lang from '../../../../languages/en'
import handleException from '../../../../services/handleException'
import { getSplitedOrder } from '../../../../actions/ordersAction'
import { renderListOrder } from '../../../../services/helper'
import { convertDateFromUTC } from '../../../../services/dst'

class SplitOrder extends React.Component {
  state = {
    disabledSplit: true,
    splitedOrder: {},
    isLoading: false
  }

  componentDidMount() {
    const { getSplitedOrder, listIdCheckedOrders } = this.props

    getSplitedOrder(listIdCheckedOrders[0])
  }

  updateSplitButtonStatus = isDisabled => {
    this.setState({
      disabledSplit: isDisabled
    })
  }

  onSplit = () => {
    const { Order, OrderDetails } = this.props.splitedOrder

    // get items for data param below
    const items = OrderDetails.map(order => {
      const item = this.listItems.find(x => x.ID === order.ID)

      if (item) {
        return {
          ItemCode: order.ItemCode,
          SKU: order.SKU,
          PCS: item.quantity
        }
      } else {
        return {
          ItemCode: order.ItemCode,
          SKU: order.SKU,
          PCS: 0
        }
      }
    })

    // data for api call
    const data = {
      Order: Order,
      Items: items
    }

    this.handleSplit(data)
  }

  handleSplit(data) {
    const _this = this

    var message = " After splitting, the "

    if (data.Order.HandlingCharge === undefined && data.Order.CollectAmount === undefined) {
      message = "";
    } else if (data.Order.HandlingCharge === undefined || data.Order.HandlingCharge === null) {
      message += "Collect Amount will be set to 0";
    } else if (data.Order.CollectAmount === undefined || data.Order.CollectAmount === null) {
      message += "Handling Charge will be set to 0";
    } else {
      message += "Handling Charge and Collect Amount will be set to 0";
    }

    const requestData = {
      OrderID: data.Order.ID,
      LastUpdateDT: data.Order.LastUpdateDT,
      Items: data.Items
    }

    showConfirm(lang.split_orders_confirm + message, () => {
      _this.setState({
        isLoading: true
      })

      splitOrders(requestData).then((res) => {
        if (res && res.data.code === 10001) {
          const results = res.data.data.splitOrderResults

          alertSplitSuccess(lang.split_orders_successfully,
            lang.split_order_to,
            `Channel order: ${results[0] && results[0].ChannelOrderID}`,
            `Channel order: ${results[1] && results[1].ChannelOrderID}`
          )

          _this.handleSplitOrderResponse()
        } else {
          handleException(res)

          _this.handleSplitOrderResponse()

        }
      }).catch((err) => {
        handleException(err)

        _this.handleSplitOrderResponse()
      })
    })
  }

  handleSplitOrderResponse = () => {
    this.setState({
      isLoading: false
    })

    // reload list and selected split orders
    renderListOrder()

    // close modal
    this.props.onCancel()
  }

  updateListItems = listItems => {
    this.listItems = listItems
  }

  render() {
    const { disabledSplit, isLoading } = this.state
    const { visible, onCancel, splitedOrder, getting_order } = this.props

    // not show form until api call is resolved
    if (!splitedOrder.Order || getting_order) return null

    const { Order } = splitedOrder

    return (
      <Modal
        className="split-order-table"
        visible={visible}
        onCancel={onCancel}
        footer={null}
        maskClosable={false}
      >
        <Spin tip="Loading" spinning={isLoading}>
          <div className="modal-title">SPLIT ORDER</div>
          <div className="table-header">
            <Row>
              <Col span={4}>
                <span className="title-header">CHANNEL</span>
                {getImageChannel(Order.ChannelName)}
              </Col>
              <Col span={10}>
                <span className="title-header">CHANNEL ORDER #</span>
                <span style={{ color: '#000' }}>{Order.ChannelOrderID}</span>
              </Col>
              <Col span={4}>
                <span className="title-header">ORDER DATE</span>
                <span style={{ color: '#000' }}>{convertDateFromUTC(Order.OrderDT).format('MM/DD/YYYY')}</span>
              </Col>
              <Col span={6}>
                <span className="title-header">SHIP TO NAME</span>
                <span style={{ color: '#000' }}>{Order.ConsigneeNameCH}</span>
              </Col>
            </Row>
          </div>
          <TableItem
            updateListItems={this.updateListItems}
            updateSplitButtonStatus={this.updateSplitButtonStatus}
          />
          <div className="footer-component">
            <div className="fix-footer">
              <div className='navbar-cancel-save-split-order split-footer'>
                <Button className="cancel" onClick={onCancel}>Cancel</Button>
                <Button
                  className="split-button"
                  type="primary"
                  disabled={disabledSplit}
                  onClick={this.onSplit}
                >Order Split</Button>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    splitedOrderId: state.ordersReducer.splitedOrderId,
    splitedOrder: state.ordersReducer.splitedOrder,
    getting_order: state.ordersReducer.getting_order,
    listIdCheckedOrders: state.ordersReducer.listIdCheckedOrders
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getSplitedOrder: (payload) => {
      dispatch(getSplitedOrder(payload))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SplitOrder)



// WEBPACK FOOTER //
// ./src/containers/orders/components/split-modal/index.js